/* eslint-disable max-len */
/* eslint-disable react/no-array-index-key */
import React, { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Dropdown from 'rc-dropdown';
import Menu, { Item as MenuItem } from 'rc-menu';
import styled from '@emotion/styled';
import IcomoonReact from 'icomoon-react';
import 'rc-dropdown/assets/index.css';
import 'rc-menu/assets/index.css';
import PropTypes from 'prop-types';
import moment from 'moment';

import iconSet from '../../../../shared/images/teambuildr-selection.json';
import Text from '../../../../shared/components/Text/Text';
import {
  setExpandedItems, updateWorkoutInfoColor, updateWorkoutInfoName, setActiveModal, shareWorkoutInfo,
} from '../../ducks/calendarActions';

const DropdownIcon = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const DropdownContainer = styled('div')`
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-right: -5px;
`;

const MenuWrapper = styled('div')`
  .rc-menu {
    border-radius: 4px !important;
    box-shadow: 0px 4px 8px 0px #3031331A !important;
    border: 1px solid #EEEEEE !important;
    margin: 0px !important;
    min-width: 0px !important;

    padding-top: 8px;
    padding-bottom: 8px;
  }
  
  .rc-menu-item:hover {
    background-color: #F5F5F5 !important;
  }
  
  .rc-menu-submenu-title {
    padding-top: 7px !important;
    padding-bottom: 7px !important;
    padding-left: 14px !important;
    cursor: pointer !important;
  }
  
  .rc-menu-submenu-title:hover {
    background-color: #F5F5F5 !important;
  }
  
  .rc-menu-submenu-arrow {
    right: 15px !important;
  }
  
  .rc-menu-submenu-popup {
    z-index: 1001 !important;
  }
  
  .color-submenu {
    width: 35px !important;
    padding: 8px !important;
    top: 86px !important;
    left: -35px !important;
    position: absolute !important;
  }
`;

const CustomDivider = styled('div')`
  height: 1px;
  margin: 8px 0;
  background-color: #EEEEEE;

  margin-left: 18px;
  margin-right: 18px;
`;

const IconContainer = styled('div')`
  display: flex;
  align-items: center;
  width: 100%;
  svg {
    margin-right: 8px;
  }
`;

const ColorIconContainer = styled('div')`
  display: flex;
  align-items: center;
`;

const NoColorIconContainer = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #9E9E9E;
  height: 24px;
  width: 24px;
  border-radius: 4px;
  cursor: pointer;
`;

// Colors for the workout color selection
const colorOptions = [
  { key: 'red', color: '#D16D6A' },
  { key: 'orange', color: '#ECB576' },
  { key: 'yellow', color: '#F9DA78' },
  { key: 'green', color: '#9DC384' },
  { key: 'blue-ish', color: '#80A4AE' },
  { key: 'blue-ish-ish', color: '#7CA6D7' },
  { key: 'purple', color: '#8B7DBE' },
  { key: 'mauve?', color: '#B87E9E' },
  { key: 'no-color-option', color: 'blank' },
];

const MenuItemHoverable = ({ hoverableItem, onMenuItemClick }) => {
  const [isHovered, setIsHovered] = useState(false);
  return (
    <MenuItem
      style={{
        paddingTop: 7, paddingBottom: 7, paddingLeft: 16, paddingRight: 16, cursor: 'pointer', background: isHovered ? '#F5F5F5' : 'white',
      }}
      onClick={(e) => onMenuItemClick(hoverableItem.key, e, hoverableItem.closeDropdown)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <IconContainer>
        <div style={{
          display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center',
        }}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <IcomoonReact
              iconSet={iconSet}
              size={16}
              icon={hoverableItem.icon}
              color={hoverableItem.color || '#9E9E9E'}
              style={hoverableItem.rotation ? { transform: `rotate(${hoverableItem.rotation}deg)` } : {}}
            />
            <Text fontSize='16px'>{hoverableItem.label}</Text>
          </div>
          <IcomoonReact iconSet={iconSet} size={12} icon='right-arrow' color='#9E9E9E' />
        </div>
      </IconContainer>
    </MenuItem>
  );
};

MenuItemHoverable.propTypes = {
  hoverableItem: PropTypes.shape({
    key: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    color: PropTypes.string,
    rotation: PropTypes.number,
    closeDropdown: PropTypes.bool,
  }).isRequired,
  onMenuItemClick: PropTypes.func.isRequired,
};

const MenuItemHoverableAlt = ({ hoverableItem, onMenuItemClick }) => {
  const [isHovered, setIsHovered] = useState(false);
  return (
    <MenuItem
      key={hoverableItem.key}
      style={{
        paddingTop: 7, paddingBottom: 7, paddingLeft: 14, cursor: 'pointer', background: isHovered ? '#F5F5F5' : 'white',
      }}
      onClick={(e) => onMenuItemClick(hoverableItem.key, e, hoverableItem.closeDropdown)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <IconContainer>
        <IcomoonReact iconSet={iconSet} size={16} icon={hoverableItem.icon} color={hoverableItem.color || '#9E9E9E'} />
        <Text fontSize='16px'>{hoverableItem.label}</Text>
      </IconContainer>
    </MenuItem>
  );
};

MenuItemHoverableAlt.propTypes = {
  hoverableItem: PropTypes.shape({
    key: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    color: PropTypes.string,
    closeDropdown: PropTypes.bool,
  }).isRequired,
  onMenuItemClick: PropTypes.func.isRequired,
};

const SubMenuTitle = ({ item }) => (
  <IconContainer>
    <IcomoonReact
      iconSet={iconSet}
      size={16}
      icon={item.icon}
      color={item.color || '#9E9E9E'}
      style={item.rotation ? { transform: `rotate(${item.rotation}deg)` } : {}}
    />
    <Text fontSize='16px'>{item.label}</Text>
  </IconContainer>
);

SubMenuTitle.propTypes = {
  item: PropTypes.shape({
    icon: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    color: PropTypes.string,
    rotation: PropTypes.number,
  }).isRequired,
};

const CalendarDropdown = ({ isWeekView = false, dateOrDay, filteredWeekDates }) => {
  const dropdownRef = useRef(null);
  const colorSubmenuRef = useRef(null);
  const dropdownContainerRef = useRef(null);
  const [maxDropdownHeight, setMaxDropdownHeight] = useState(215);
  const [localDropdownVisible, setLocalDropdownVisible] = useState(false);
  const [selectedColor, setSelectedColor] = useState('');
  const [colorSubmenuShouldDisplayHorizontal, setColorSubmenuShouldDisplayHorizontal] = useState(false);
  const dropdownVisible = useSelector((state) => state.calendar.data.dropdownVisible);
  const selectedProgramDayNumber = useSelector(
    (state) => state.calendar.data.selectedProgramDayNumber,
  );
  const selectedDate = useSelector((state) => state.calendar.data.selectedDate);
  const effectiveDate = isWeekView ? dateOrDay : selectedDate;
  const date = new Date(effectiveDate);
  const endpointFormattedDate = moment(date).format('YYYY-MM-DD');
  const programType = useSelector((state) => state.calendar.data.programType);
  const workoutDetails = programType === 'free-form-program'
    ? useSelector((state) => state.calendar.data.nonDateBasedProgramItems[
      selectedProgramDayNumber
    ])
    : useSelector((state) => state.calendar.data.calendarItems[endpointFormattedDate]);
  const selectedReduxAthlete = useSelector((state) => state.calendar.data.selectedReduxAthlete);
  const selectedCalendar = useSelector((state) => state.calendar.data.selectedReduxCalendar);
  const selectedReduxNonDateBasedProgram = useSelector(
    (state) => state.calendar.data.selectedReduxNonDateBasedProgram,
  );
  const currentUser = useSelector((state) => state.auth.data.currentUser);
  const dispatch = useDispatch();

  useEffect(() => {
    if (workoutDetails?.color) {
      setSelectedColor(workoutDetails.color);
    }
  }, [workoutDetails]);

  const handleMenuItemClick = (key, e, closeDropdown) => {
    if (!closeDropdown) {
      e.domEvent.stopPropagation();
    }
  };

  const handleVisibleChange = (visible) => {
    setLocalDropdownVisible(visible);

    if (visible) {
      const dropdownIcon = dropdownRef.current.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const calculatedMaxHeight = windowHeight - dropdownIcon.top - 35;
      const maxHeight = dropdownIcon.top
        - 35 > calculatedMaxHeight ? dropdownIcon.top - 35 : calculatedMaxHeight;
      setMaxDropdownHeight(maxHeight);
    }
  };

  const handleUpdateColor = (color) => {
    let submissionObject;
    if (programType === 'free-form-program') {
      submissionObject = {
        color,
        // dayNumber: selectedProgramDay,
        programId: selectedReduxNonDateBasedProgram?.id,
      };
    } else {
      submissionObject = {
        color,
        date: moment(effectiveDate).format('YYYY-MM-DD'),
      };
      if (Object.keys(selectedReduxAthlete).length) {
        submissionObject.userId = selectedReduxAthlete.id;
      } else {
        submissionObject.calendarId = selectedCalendar.id;
      }
    }

    if (workoutDetails?.title) {
      submissionObject.title = workoutDetails.title;
    }
    dispatch(updateWorkoutInfoColor(
      currentUser.accountCode,
      submissionObject,
    ));
  };

  const handleClearWorkoutTitle = () => {
    let submissionObject;
    if (programType === 'free-form-program') {
      submissionObject = {
        color: workoutDetails?.color || '#444444',
        // dayNumber: selectedProgramDay,
        title: '', // Clear the title by setting it to empty string
        programId: selectedReduxNonDateBasedProgram?.id,
      };
    } else {
      submissionObject = {
        color: workoutDetails?.color || '#444444',
        date: moment(effectiveDate).format('YYYY-MM-DD'),
        title: '', // Clear the title by setting it to empty string
      };
      if (Object.keys(selectedReduxAthlete).length) {
        submissionObject.userId = selectedReduxAthlete.id;
      } else {
        submissionObject.calendarId = selectedCalendar.id;
      }
    }
    dispatch(updateWorkoutInfoName(
      currentUser.accountCode,
      submissionObject,
    ));
  };

  useEffect(() => {
    /** close the color sub menu if the parent container closes on resize */
    if (colorSubmenuRef.current && colorSubmenuRef.current.list) {
      colorSubmenuRef.current.list.style.display = localDropdownVisible ? 'flex' : 'none';
    }

    const handleResize = () => {
      if (localDropdownVisible) {
        setLocalDropdownVisible(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [localDropdownVisible, dropdownVisible]);

  useEffect(() => {
    if (!dropdownVisible) {
      setLocalDropdownVisible(false);
    }
  }, [dropdownVisible]);

  useEffect(() => {
    if (dropdownRef.current) {
      const rect = dropdownRef.current.getBoundingClientRect();
      const distanceFromBottom = window.innerHeight - rect.bottom;

      if (distanceFromBottom <= 500) {
        setColorSubmenuShouldDisplayHorizontal(true);
      } else {
        setColorSubmenuShouldDisplayHorizontal(false);
      }
    }
  }, [dropdownRef.current, dropdownVisible, localDropdownVisible]);

  const handleColorSelect = (e, color) => {
    e.domEvent.stopPropagation();
    setSelectedColor(color);
    handleUpdateColor(color);
  };

  const handleExpandExercises = () => {
    const newExpandedItems = {};
    // Check if workoutDetails and exercises exist
    if (workoutDetails && workoutDetails.exercises && workoutDetails.exercises.length > 0) {
      // Iterate over all exercises for the selected date
      workoutDetails.exercises.forEach((exercise) => {
        // Set each assignedId as a key with value true
        if (exercise.assignedId) {
          newExpandedItems[exercise.assignedId] = true;
        }
      });
    }
    dispatch(setExpandedItems(newExpandedItems));
  };

  const handleCollapseExercises = () => {
    const newExpandedItems = {};
    // Check if workoutDetails and exercises exist
    if (workoutDetails && workoutDetails.exercises && workoutDetails.exercises.length > 0) {
      // Iterate over all exercises for the selected date
      workoutDetails.exercises.forEach((exercise) => {
        // Set each assignedId as a key with value false
        if (exercise.assignedId) {
          newExpandedItems[exercise.assignedId] = false;
        }
      });
    }
    dispatch(setExpandedItems(newExpandedItems));
  };

  const colorSubmenu = (
    <Menu
      ref={colorSubmenuRef}
      className='color-submenu'
      style={{
        padding: 8,
        top: colorSubmenuShouldDisplayHorizontal ? 0 : 118,
        left: colorSubmenuShouldDisplayHorizontal ? -270 : -47,
        backgroundColor: '#FFFFFF',
        display: 'flex',
        flexDirection: colorSubmenuShouldDisplayHorizontal ? 'row' : 'column',
        border: 'none',
        borderRadius: 4,
        width: 'fit-content',
        gap: 4,
        marginTop: 0,
        marginBottom: 0,
        alignItems: 'center',
      }}
    >
      {colorOptions.map((color) => {
        if (color.color !== 'blank') {
          return (
            <MenuItem
              key={color.key}
              onClick={(e) => handleColorSelect(e, color.color)}
            >
              <ColorIconContainer>
                <div
                  style={{
                    width: 24,
                    height: 24,
                    borderRadius: 4,
                    backgroundColor: color.color,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    cursor: 'pointer',
                  }}
                >
                  {color.color === selectedColor ? (
                    <IcomoonReact
                      iconSet={iconSet}
                      size={12}
                      icon='checkmark'
                      color='white'
                    />
                  ) : null}
                </div>
              </ColorIconContainer>
            </MenuItem>
          );
        }
        return (
          <MenuItem key={color.key} onClick={(e) => handleColorSelect(e, color.color)}>
            <NoColorIconContainer>
              <IcomoonReact
                iconSet={iconSet}
                size={12}
                icon='opt-out'
                color='#9E9E9E'
              />
            </NoColorIconContainer>
          </MenuItem>
        );
      })}
    </Menu>
  );

  // Update the menuItems array to include Collapse Exercises option
  const menuItems = [
    {
      key: '1', icon: 'expand2', label: 'Expand Exercises', shortcut: '⌘+E', closeDropdown: true,
    },
    {
      key: '1a', icon: 'collapse', label: 'Collapse Exercises', closeDropdown: true,
    },
    {
      key: '2', icon: 'duplicate', label: 'Copy', shortcut: '⌘+C', closeDropdown: false,
    },
    { divider: true },
    {
      key: '5', icon: 'save2', label: 'Save', shortcut: '⌘+S', closeDropdown: false,
    },
    {
      key: '6', icon: 'send-alt', label: 'Share Workout', rotation: -45, closeDropdown: false,
    },
    {
      key: '7',
      icon: 'pencil',
      label: 'Change Workout Color',
      rotation: 90,
      submenu: colorSubmenu,
      closeDropdown: false,
    },
    {
      key: '7a', icon: 'remove', label: 'Clear Workout Title', closeDropdown: true,
    },
    { divider: true },
    {
      key: '8', icon: 'delete', label: 'Clear Workout Items', color: 'red', closeDropdown: true,
    },
  ];

  // Update the renderMenuItems function to handle the new Collapse Exercises option
  const renderMenuItems = () => menuItems.map((item, index) => {
    if (item.divider) return <CustomDivider key={`divider-${index}`} />;
    if (item.submenu) {
      return (
        <Dropdown
          key={item.key}
          trigger={['click']}
          overlay={item.submenu}
          placement='rightTop'
        >
          <MenuItem
            style={{
              paddingTop: 7, paddingBottom: 7, paddingLeft: 14, cursor: 'pointer', background: 'white',
            }}
            onClick={(e) => e.domEvent.stopPropagation()}
          >
            <IconContainer>
              <div style={{
                display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center',
              }}
              >
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <IcomoonReact
                    iconSet={iconSet}
                    size={16}
                    icon={item.icon}
                    color={item.color || '#9E9E9E'}
                    style={item.rotation ? { transform: `rotate(${item.rotation}deg)` } : {}}
                  />
                  <Text fontSize='16px'>{item.label}</Text>
                </div>
                <IcomoonReact iconSet={iconSet} size={12} icon='right-arrow' color='#9E9E9E' />
              </div>
            </IconContainer>
          </MenuItem>
        </Dropdown>
      );
    }

    // Handle the "Expand Exercises" menu item specifically
    if (item.key === '1') {
      return (
        <MenuItemHoverableAlt
          key={item.key}
          hoverableItem={item}
          onMenuItemClick={() => {
            handleExpandExercises();
            // Close dropdown after expanding
            setLocalDropdownVisible(false);
          }}
        />
      );
    }

    // Handle the "Collapse Exercises" menu item
    if (item.key === '1a') {
      return (
        <MenuItemHoverableAlt
          key={item.key}
          hoverableItem={item}
          onMenuItemClick={() => {
            handleCollapseExercises();
            // Close dropdown after collapsing
            setLocalDropdownVisible(false);
          }}
        />
      );
    }

    // Handle the "Share Workout" menu item specifically
    if (item.key === '6') {
      return (
        <MenuItemHoverableAlt
          key={item.key}
          hoverableItem={item}
          onMenuItemClick={() => {
            // Open the modal with modalData for week view context
            const modalData = isWeekView ? {
              weekViewDate: effectiveDate,
              isFromWeekView: true,
            } : null;
            dispatch(setActiveModal('shareWorkoutModal', modalData));
            // Make the API request to get share link
            let shareData;
            if (programType === 'free-form-program') {
              shareData = {
                // dayNumber: selectedProgramDay,
                programId: selectedReduxNonDateBasedProgram?.id,
              };
            } else {
              shareData = {
                date: moment(effectiveDate).format('YYYY-MM-DD'),
              };
              // Add calendarId or userId if available
              if (Object.keys(selectedReduxAthlete).length) {
                shareData.userId = selectedReduxAthlete.id;
              } else {
                shareData.calendarId = selectedCalendar.id;
              }
            }

            dispatch(shareWorkoutInfo(currentUser.accountCode, shareData));
            // Close dropdown after opening modal
            setLocalDropdownVisible(false);
          }}
        />
      );
    }

    // Handle the "Save" menu item specifically
    if (item.key === '5') {
      return (
        <MenuItemHoverableAlt
          key={item.key}
          hoverableItem={item}
          onMenuItemClick={() => {
            dispatch(setActiveModal('saveWorkoutModal'));
            // Close dropdown after opening modal
            setLocalDropdownVisible(false);
          }}
        />
      );
    }

    // Handle the "Clear Workout Items" menu item
    if (item.key === '8') {
      return (
        <MenuItemHoverableAlt
          key={item.key}
          hoverableItem={item}
          onMenuItemClick={() => {
            // Pass the effective date as modalData when in week view
            const modalData = isWeekView ? {
              date: effectiveDate,
              isFromWeekView: true,
            } : null;
            dispatch(setActiveModal('clearWorkoutItemsModal', modalData));
            // Close dropdown after opening modal
            setLocalDropdownVisible(false);
          }}
        />
      );
    }

    // Handle the "Clear Workout Title" menu item
    if (item.key === '7a') {
      return (
        <MenuItemHoverableAlt
          key={item.key}
          hoverableItem={item}
          onMenuItemClick={() => {
            handleClearWorkoutTitle();
            // Close dropdown after clearing title
            setLocalDropdownVisible(false);
          }}
        />
      );
    }

    // Handle the "Copy" menu item specifically
    if (item.key === '2') {
      return (
        <MenuItemHoverableAlt
          key={item.key}
          hoverableItem={item}
          onMenuItemClick={() => {
            // Calculate week range when in week view
            let modalData = null;
            if (isWeekView) {
              // Find the clicked date in filteredWeekDates by comparing dates
              const clickedDate = moment(date);
              const weekStartDate = filteredWeekDates.find((momentDate) => momentDate.isSame(clickedDate, 'day')) || filteredWeekDates[0];
              const weekEndDate = filteredWeekDates[filteredWeekDates.length - 1];
              modalData = {
                weekStartDate: weekStartDate.toDate(),
                weekEndDate: weekEndDate.toDate(),
                isFromWeekView: true,
              };
            }
            dispatch(setActiveModal('copyWorkoutModal', modalData));
            // Close dropdown after opening modal
            setLocalDropdownVisible(false);
          }}
        />
      );
    }

    return (
      <MenuItemHoverableAlt key={item.key} hoverableItem={item} onMenuItemClick={handleMenuItemClick} />
    );
  });

  return (
    <Dropdown
      trigger={['click']}
      overlay={(
        <MenuWrapper ref={dropdownContainerRef}>
          <Menu
            mode='vertical'
            style={{
              width: 280,
              minWidth: 0,
              maxHeight: maxDropdownHeight,
              overflowY: 'auto',
              marginBottom: 0,
            }}
          >
            {renderMenuItems()}
          </Menu>
        </MenuWrapper>
      )}
      visible={localDropdownVisible}
      onVisibleChange={handleVisibleChange}
    >
      <DropdownContainer ref={dropdownRef}>
        <DropdownIcon>
          <IcomoonReact iconSet={iconSet} size={18} icon='dots' color='#9E9E9E' style={{ transform: 'rotate(90deg)' }} />
        </DropdownIcon>
      </DropdownContainer>
    </Dropdown>
  );
};

CalendarDropdown.propTypes = {
  isWeekView: PropTypes.bool,
  dateOrDay: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  filteredWeekDates: PropTypes.instanceOf(Array),
};

CalendarDropdown.defaultProps = {
  isWeekView: false,
  dateOrDay: null,
  filteredWeekDates: [],
};

export default CalendarDropdown;
